var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var CommonBusiness = function (storeContainer) {
    var store = storeContainer.store;
    var commonStore = store.newCreateRequestStore.commonStore;
    var propsConnect = {
        priority: commonStore.priority,
        woTypeId: commonStore.woTypeId,
        woDetail: commonStore.woDetail,
        isDTC: commonStore.isDTC
    };
    var dispatchConnect = {
        getWoDetail: function (woId, isReactive) { return commonStore.getWoDetail(woId, isReactive); },
        getIsEnableDTCConfig: function () { return commonStore.getIsEnableDTCConfig(); },
    };
    return __assign(__assign({}, propsConnect), dispatchConnect);
};
